module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "panel m-w-1280"
  }, [_c('div', {
    staticClass: "panel-top m-w-1280 common-header"
  }, [_c('el-row', {
    staticClass: "p-lf-30 m-w-1280",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-row', {
    staticClass: "common-header-row",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemImg),
      expression: "systemImg"
    }],
    staticClass: "common-header-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.systemImg
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.systemImg),
      expression: "systemImg"
    }],
    staticClass: "separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "fz-20 fw-b c-black common-header-name"
  }, [_vm._v(_vm._s(_vm.systemName))]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "max-width": "1000px"
    },
    attrs: {
      "type": "flex"
    }
  }, _vm._l((_vm.topMenu), function(menu) {
    return _c('div', {
      staticClass: "top-menu",
      class: {
        'top-active': menu.selected
      },
      on: {
        "click": function($event) {
          _vm.switchTopMenu(menu)
        }
      }
    }, [_vm._v(_vm._s(menu.title))])
  }))]), _vm._v(" "), _c('el-row', {
    class: {
      'm-r-60': !_vm.isSmall, 'm-r-40': _vm.isSmall
    },
    attrs: {
      "type": "flex"
    }
  }, [_c('span', {
    staticClass: "c-999 fz-16"
  }, [_vm._v("欢迎回来，" + _vm._s(_vm.username))])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('div', [_c('div', {
    staticClass: "fz-14"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'messageCenter'
      }
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "is-dot": _vm.isUnRead
    }
  }, [_c('span', {
    staticClass: "top-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-message"
  })])])])])]), _vm._v(" "), _c('div', [_c('el-dropdown', {
    on: {
      "command": _vm.handleMenu
    }
  }, [_c('span', {
    staticClass: "top-icon m-r-16 m-l-20"
  }, [_c('i', {
    staticClass: "iconfont icon-user"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "changePwd"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "logout"
    }
  }, [_vm._v("退出")])])])])])])]), _vm._v(" "), _c('el-col', {
    staticClass: "panel-center",
    class: {
      't-70': !_vm.isSmall, 't-60': _vm.isSmall
    },
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showLeftMenu),
      expression: "!showLeftMenu"
    }],
    staticClass: "w-200 ovf-auto mh-100p",
    style: ({
      width: _vm.mediaWidth + 'px!important'
    }),
    attrs: {
      "id": "leftMenu"
    }
  }, [_c('leftMenu', {
    ref: "leftMenu",
    attrs: {
      "menuData": _vm.menuData,
      "menu": _vm.menu,
      "secId": _vm.secId,
      "thirdId": _vm.thirdId
    },
    on: {
      "setActiveId": _vm.setActiveId
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "panel-c-c",
    class: {
      'hide-leftMenu': _vm.hasChildMenu, 'panel-c-c-no': _vm.isFlow
    },
    style: ({
      left: _vm.mediaWidth + 'px!important'
    }),
    attrs: {
      "id": "panelContent"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')])])])])]), _vm._v(" "), _c('changePwd', {
    ref: "changePwd"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c225033c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1984
// module chunks = 2